import React from "react";

function ConfirmDeletePopup({ isOpen, onClose, onConfirm, itemName }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-500 bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-lg font-semibold text-center text-gray-800">
          Confirmar eliminación
        </h2>
        <p className="text-center text-gray-600 mt-4">
          ¿Estás seguro de que deseas eliminar <strong>{itemName}</strong>? Esta
          acción no se puede deshacer.
        </p>
        <div className="flex justify-center space-x-4 mt-6">
          <button
            onClick={onConfirm}
            className="bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600"
          >
            Eliminar
          </button>
          <button
            onClick={onClose}
            className="bg-gray-500 text-white py-2 px-4 rounded-lg hover:bg-gray-600"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeletePopup;
